exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkButton-25Ni0{text-decoration:none !important;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;color:#fff;margin-right:40px}.linkButton-25Ni0:last-child{margin-right:0}", ""]);

// exports
exports.locals = {
	"linkButton": "linkButton-25Ni0"
};